import { render, staticRenderFns } from "./SuperTalkDetails.vue?vue&type=template&id=0be59562&scoped=true"
import script from "./SuperTalkDetails.vue?vue&type=script&lang=js"
export * from "./SuperTalkDetails.vue?vue&type=script&lang=js"
import style0 from "./SuperTalkDetails.vue?vue&type=style&index=0&id=0be59562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be59562",
  null
  
)

export default component.exports